<script setup lang="ts">
import { onMounted, ref } from 'vue'

const props = defineProps<{
  achievement: string
}>()

// 动画状态
const isAnimating = ref(false)

// 成就图标
const getAchievementIcon = (achievement: string) => {
  switch (achievement) {
    case '饲料大师':
      return '🍽️'
    case '深渊凝视者':
      return '👁️'
    case '味觉崩坏':
      return '🤮'
    default:
      return '🏆'
  }
}

// 成就描述
const getAchievementDescription = (achievement: string) => {
  switch (achievement) {
    case '饲料大师':
      return '投喂了至少5种不同的饲料'
    case '深渊凝视者':
      return '深渊点数达到500'
    case '味觉崩坏':
      return '投喂了所有可用的饲料类型'
    default:
      return '解锁了一个神秘成就'
  }
}

// 入场动画
onMounted(() => {
  isAnimating.value = true

  // 振动效果
  const shakeAnimation = setTimeout(() => {
    isAnimating.value = false
  }, 300)

  return () => clearTimeout(shakeAnimation)
})
</script>

<template>
  <div class="achievement-container" :class="{ shake: isAnimating }">
    <div class="achievement-content">
      <div class="achievement-icon">
        {{ getAchievementIcon(achievement) }}
      </div>
      <div class="achievement-info">
        <div class="achievement-title">成就解锁！</div>
        <div class="achievement-name">{{ achievement }}</div>
        <div class="achievement-description">
          {{ getAchievementDescription(achievement) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.achievement-container {
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  filter: drop-shadow(0 0 20px rgba(255, 215, 0, 0.5));
  animation: slideIn 0.5s ease-out forwards;
}

.achievement-content {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
  border: 2px solid #ffd700;
  border-radius: 10px;
  padding: 15px;
  max-width: 350px;
}

.achievement-icon {
  font-size: 40px;
  margin-right: 15px;
  background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.achievement-info {
  color: white;
}

.achievement-title {
  color: #ffd700;
  font-size: 14px;
  margin-bottom: 5px;
}

.achievement-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.achievement-description {
  font-size: 14px;
  opacity: 0.8;
}

.shake {
  animation: shake 0.3s ease-in-out;
}

@keyframes shake {
  0% {
    transform: translateX(-50%) rotate(0deg);
  }
  25% {
    transform: translateX(-53%) rotate(-5deg);
  }
  50% {
    transform: translateX(-50%) rotate(0deg);
  }
  75% {
    transform: translateX(-47%) rotate(5deg);
  }
  100% {
    transform: translateX(-50%) rotate(0deg);
  }
}

@keyframes slideIn {
  0% {
    transform: translateX(-50%) translateY(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}
</style>
